/* import __COLOCATED_TEMPLATE__ from './connected-accounts.hbs'; */
/* RESPONSIBLE TEAM: team-omni */
import Component from '@glimmer/component';

interface Signature {
  Args: {
    slackIntegrations: any[];
    authenticate: () => void;
    showRemoveModal: (integration: any) => void;
  };
}

export default class ConnectedAccounts extends Component<Signature> {
  fetchError?: string;

  get firstSlackIntegration() {
    let integrations = this.args.slackIntegrations;
    if (Array.isArray(integrations)) {
      return integrations[0];
    }
    if (
      integrations &&
      typeof integrations === 'object' &&
      typeof (integrations as any).objectAt === 'function'
    ) {
      return (integrations as any).objectAt(0);
    }
    return undefined;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Slack::ConnectedAccounts': typeof ConnectedAccounts;
    'new-settings/channels/slack/connected-accounts': typeof ConnectedAccounts;
  }
}
